import React, { useContext, useState, useEffect } from "react"
import { Breadcrumbs, Dropdowns } from "../../../AbstractElements";
import { Card, CardBody, Container } from "reactstrap";
import SeachBar from "../../UiKits/SearchBar";
import { useParams } from "react-router";
import useFetchUsersAndCourses from "../../../hook/useFetchUsersAndCourses";
import StudentTable from "./StudentTable";
import CourseDropdown from "../../../Common/Component/CourseDropdown";
import courseContext from "../../../Helper/Courses";
import UserDetail from "./UserDetails";
import UserStatusTable from "./UserStatusTable";
import { composeEmail } from "./EmailHandler";

const UsersManagement = () => {
  const { students, loading, courses, setStudents } = useFetchUsersAndCourses();
  const [search, setSearch] = useState("");
  const [filterStudent, setFilterStudent] = useState([]);
  const [selectCourse, setSelectCourse] = useState("All Courses");
  const { activeCourse } = useContext(courseContext);
  const url = useParams();
  const [detailsModel, setDetailsModel] = useState({ show: false, details: null });

  useEffect(() => {
    handleSearchByCourse(selectCourse);
  }, [selectCourse, students]);

  const handleSearchChange = (value) => setSearch(value);

  const handleSearchByCourse = (courseId) => {
    if (courseId === "All Courses") {
      setFilterStudent(students);
    } else {
      setFilterStudent(students.filter(student => student?.courseIds?.includes(courseId)));
    }
  };
  const emailOptions = [
    { item: "Email All", onClick: () => composeEmail("all", students) },
    { item: "Email All Verified only", onClick: () => composeEmail("enroll", students) },
  ];

  return (
    <div>
      <Breadcrumbs mainTitle={"User Management"} />
      <Container fluid={true} className="dashboard-default">
        <UserStatusTable students={filterStudent} loading={loading} />
        <Card className="p-3">
          <div className="header-row d-flex align-items-center">
            <SeachBar search={search} setSearch={handleSearchChange} loading={loading} />
            <CourseDropdown
              isUser={url}
              setSelectCourse={setSelectCourse}
              selectCourse={selectCourse}
              loading={loading}
            />
            <div className="fee-table-header">
              <CardBody className="dropdown-basic p-0">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Dropdowns
                    attrDropBtn={{ className: "dropbtn module-btn show-color" }}
                    attrDropMenu={{ className: "dropdown-content module-dropdown" }}
                    dropItem={emailOptions}
                    dropBtnContent={
                      <>
                        Send Emails <i className="icofont icofont-arrow-down ml-5"></i>
                      </>
                    }
                    attrDropItem={{ toggle: false }}
                    loading={loading}
                  />
                </div>
              </CardBody>
            </div>
          </div>
          <div className="m-b-50 ant-design-table not-margin">
            <StudentTable
              students={filterStudent}
              search={search}
              loading={loading}
              setDetailsModel={setDetailsModel}
              courses={courses}
            />
          </div>
          {detailsModel.show && (
            <UserDetail
              students={students}
              detailsModel={detailsModel}
              setDetailsModel={setDetailsModel}
              setStudents={setStudents}
            />
          )}
        </Card>
      </Container>
    </div>
  );
}
export default UsersManagement